import { mainApiUrl } from './consts';

export async function uploadImage(input) {
  const reader = new FileReader();

  reader.readAsDataURL(input);

  const formData = new FormData();
  formData.append('image', input);

  const uploadFiles = await fetch(`${mainApiUrl}/files/image-upload`, {
    method: 'POST',
    body: formData
  });

  const thumbnailJson = await uploadFiles.json();

  if (thumbnailJson.imageUrl) return thumbnailJson.imageUrl;
  else return '';
}

export async function getImageUrls(fileArray) {

  try {

    const promArr = fileArray.map(item => uploadImage(item));
    const urlArray = await Promise.all(promArr);

    return { success: true, urlArray };

  } catch(err) {
    return { success: false };
  }
}

export async function uploadFile(fileInput) {

  let fileUrl;

  if (fileInput) {

    const reader = new FileReader();
    reader.readAsDataURL(fileInput);

    const formData = new FormData();
    formData.append('file', fileInput);

    const uploadFile = await fetch(`${mainApiUrl}/files/file-upload`, {
      method: 'POST',
      body: formData
    });

    const fileJson = await uploadFile.json();
    fileUrl = fileJson.fileUrl;
  }

  return fileUrl;
}
